<template>
    <div @click="showProfile" style="display: flex; align-items: center;">
        <div style="margin-right: 8px;">
            <ProfileImage style="width: 40px;" :image-path="memberInfo.image_path"></ProfileImage>
        </div>
        <div>
            <div style="flex: 1; display: flex; align-items: center; gap: 3px;">
                <div style="font-weight: 700; line-height: 24px; font-size: 14px;">{{ memberInfo.nic_name }}</div>
                <div style="font-weight: 700; font-size: 12px; color: var(--color-main);">{{ memberInfo.position }}</div>
            </div>
            <div style="font-size: 12px; line-height: 16px; color: #606060;">{{ memberInfo.place_name }}</div>
        </div>
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import { MEMBER_TYPE, TEAM_TYPE } from "../../Constants";

export default {
    name: 'CommonProfileNew',
    components: { ProfileImage },
    props: {
        memberInfo: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            TEAM_TYPE: TEAM_TYPE
        }
    },
    methods: {
        showProfile() {
            this.$Util.showProfile(this.memberInfo.member_idx, MEMBER_TYPE.USER, 0);
        },
    }
}
</script>

<style scoped></style>